import {publicRoute} from './localization/publicRoutes';
// A new visitor can use public pages without downloading the authentication SDK.
// If persistence cannot be inspected, restore auth normally rather than guessing.
export async function needsAuthentication(pathname,search,browser=window){
 if((!publicRoute(pathname)&&!/^\/capabilities\/?$/.test(pathname))||new URLSearchParams(search).has('sessionID'))return true;
 try{
  if(Object.keys(browser.localStorage).some(key=>key.startsWith('firebase:authUser:')))return true;
  if(typeof browser.indexedDB?.databases!=='function')return true;
  return (await browser.indexedDB.databases()).some(db=>db.name==='firebaseLocalStorageDb');
 }catch(_){return true;}
}
